// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { RolePermission, RolePermissionSchema } from 'api/gen/RolePermission';

const requiredPart = t.interface({
  content: t.union([t.array(RolePermissionSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelRolePermissionSchema = excess(requiredPart);

export interface PagedModelRolePermission extends t.TypeOf<typeof PagedModelRolePermissionSchema> {}
